import { matchPath, Outlet, useLocation} from 'react-router-dom';
import Header from '../../common/components/DetailsViewHeader';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../template/store';
import OblDetails from '../../common/components/OblDetails';
import MainTable from './components/MainTable';
import { AESDecrypt } from '../../../encrypt-util';
import DashboardContainer from '../../../components/common/DashboardContainer';
import DocumentHistory from '../blDetails/DocumentHistory';
import { useDispatch } from 'react-redux';
import { updateDashbaordName, updateSearchInputValueNT } from '../../common/slices/navbarTop';
import { useInstDashName } from '../../../hooks/useDashName';
import { getUnprefixedPathname } from '../../../helpers/utils';

const InstructionDtls = () => {
  const location = useLocation();
  const dispatch = useDispatch()

  const paymentStatus = useSelector(
    (state: RootState) => state.instructionDashboard.showPayment
  );

  const releaseStatus = useSelector(
    (state: RootState) => state.instructionDashboard.showRelease
  );

  const instDashboardName = useInstDashName()

  useEffect(() => {
    dispatch(updateDashbaordName(instDashboardName));
    dispatch(updateSearchInputValueNT(''))
  }, []);
  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';

  const urlparts = getUnprefixedPathname().split('/');
  const page = urlparts[urlparts.length - 1];
  const decpage = urlparts.length ==3?AESDecrypt(page):''; 
  const path = location.pathname.startsWith(APP_PATH_PREFIX)
    ? location.pathname.slice(APP_PATH_PREFIX.length)
    : location.pathname;
  var parts = path.split('/');
  var blslider = parts[1];

  const sideWidth = Object.entries({
    [`${APP_PATH_PREFIX}/instruction`] : 0,
    [`${APP_PATH_PREFIX}/instruction/snooze/:blEventId`]:6,
    [`${APP_PATH_PREFIX}/instruction/bl/:blNum/snooze/:blEventId`]:6,
    [`${APP_PATH_PREFIX}/instruction/bl/:blNum/:encrypt/unpaid`] : 6,
    [`${APP_PATH_PREFIX}/instruction/bl/:blNum/:encrypt/unpaid/payment`] : 6,
    [`${APP_PATH_PREFIX}/instruction/bl/:blNum/:encrypt/unpaid/payment/:pmtid`] : 6

  }).find(([path,_])=>matchPath(path, location.pathname))?.[1]??9

  const isInner = location.pathname.includes('instruction/bl/')

  return (
    <DashboardContainer
    sideWidth={sideWidth}
    middleScroll={!isInner && (decpage == '812' || decpage == '811' ||
    decpage == '813' || decpage == '815' || decpage == '822' || decpage == '824' ||
    !matchPath(`${APP_PATH_PREFIX}/instruction/:encrypt`, location.pathname)) }
    inner ={isInner}
   
    middleChildren={
      location.pathname.includes('blsliderinstruction') ?
      <OblDetails blslider={blslider} />
      :((decpage != '812' && decpage != '811' &&
                decpage != '813' && decpage != '815' && decpage != '822' && decpage != '824' &&
        matchPath(`${APP_PATH_PREFIX}/instruction/:encrypt`, location.pathname))
        || isInner) && !location.pathname.includes('snooze') ?
        <>
          <Header
            paymentStatus={paymentStatus}
            releaseStatus={releaseStatus}
          />
          <DocumentHistory/>
        </>
      :<Outlet/>
    }
    >
      <MainTable />
    </DashboardContainer>
  )
}

export default InstructionDtls;
